export const zodEmailValidator = (value: string) => {
  if (!value) return false
  if (!value.indexOf('@')) return false
  if (!value.indexOf('.')) return false
  if (value.indexOf('@') !== value.lastIndexOf('@')) return false
  return true;
}
